export default "__VITE_ASSET__b5vCqd5m__"